import { render, staticRenderFns } from "./membercentre.vue?vue&type=template&id=3c748a25&scoped=true&"
import script from "./membercentre.vue?vue&type=script&lang=js&"
export * from "./membercentre.vue?vue&type=script&lang=js&"
import style0 from "./membercentre.vue?vue&type=style&index=0&id=3c748a25&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c748a25",
  null
  
)

export default component.exports